import { CreatorFeatures } from '@/modules/accounts/types.ts'
import type { Creator } from '@/modules/creators/types.ts'

export interface AutomationItem {
  title: string | ((creator: Creator) => string)
  type: string
  fromTime?: Date | null
  toTime?: Date | null
  requiredFeatures?: CreatorFeatures[]
}

export type AutomationRunBehavior =
  | 'RUN_WHEN_ONLINE'
  | 'ALWAYS_RUN'
  | 'CUSTOM_TIMES'

export interface AutomationRunBehaviorItem {
  name: string
  type: AutomationRunBehavior
}

export const automationRunBehaviorItems: Array<AutomationRunBehaviorItem> = [
  {
    name: 'Run 24/7',
    type: 'ALWAYS_RUN',
  },
  {
    name: 'Run only when a Member is online',
    type: 'RUN_WHEN_ONLINE',
  },
  {
    name: 'Run at a Custom Time',
    type: 'CUSTOM_TIMES',
  },
]

export const automationItems: Array<AutomationItem> = [
  {
    type: 'PROMOTIONS_CHECKER',
    title: 'Promotion Reactivator',
  },
  {
    type: 'ONLINE_MASS_MESSAGES',
    title: 'Online Mass Messages',
    requiredFeatures: [CreatorFeatures.bulk_messages],
  },
  {
    type: 'NEW_FANS_CHECKER',
    title: (creator: Creator) => {
      let features = 'New Subs List'

      if (creator.features.includes(CreatorFeatures.fan_numbering)) {
        features = 'Fan Numbering, ' + features
      }

      if (creator.features.includes(CreatorFeatures.welcome_messages)) {
        features = 'Welcome Messages, ' + features
      }

      return features
    },
  },
  {
    type: 'EXPIRING_FANS_MESSAGES',
    title: 'Expiring Fans Messages',
    requiredFeatures: [CreatorFeatures.expiring_fans],
  },
  {
    type: 'PPV_FOLLOW_UP',
    title: 'PPV Follow-Ups',
    requiredFeatures: [CreatorFeatures.follow_up_messages],
  },
  {
    type: 'FOLLOW_BACK',
    title: 'Auto-Follow Expired Fans',
    requiredFeatures: [CreatorFeatures.auto_follow],
  },
  {
    type: 'TRANSACTIONS_UPLOADER',
    title: 'Statistics Updater',
  },
  {
    type: 'TIERS',
    title: 'Fan Spend List Updater',
    requiredFeatures: [CreatorFeatures.tiers],
  },
  {
    type: 'ONLINE_COUNT_CHECKER',
    title: 'Fan Activity Checker for Heatmap',
    requiredFeatures: [CreatorFeatures.stats],
  },
]

export function hasAutomationItemFeature(
  creator: Creator,
  item: AutomationItem,
) {
  if (!item.requiredFeatures || item.requiredFeatures.length === 0) {
    return true
  }

  return item.requiredFeatures.some((featureKey) =>
    creator.features.includes(featureKey),
  )
}
